import React from 'react';
import { WardDto, HSFacilityGroup } from 'server-openapi';
import styled from 'styled-components';
import { Grid } from '../../../../kit/Grid';
import { DateInput } from '../../../../kit/Forms/DateInput';
import { Layout } from '../../../../kit/Layout';
import { Text } from '../../../../kit/Text';

interface IProps {
  onSelectFacility: (facility: WardDto) => void;
  selectedFacility?: WardDto;
  facilityGroup?: HSFacilityGroup;
  selectedStartMonth?: Date;
  onSelectStartMonth: (startMonth?: Date) => void;
}

export function FacilityMedicationChangesReportFilters(props: IProps) {
    return (
        <FilterContainer alignItemsCenter cols={1} colsMobile={1} gap={1}>
            <DateContainer horizontal align={'center'} gap={0.5}>
                <PlaceholderText>Select Month:</PlaceholderText>
                <DateInput
                    name="startMonth"
                    monthOnly={true}
                    preventFutureMonths={true}
                    fullWidth
                    value={props.selectedStartMonth}
                    onChange={(_, v) => props.onSelectStartMonth(v)}
                />
            </DateContainer>
        </FilterContainer>
    );
}

const FilterContainer = styled(Grid)`
  width: 100%;
`;

const DateContainer = styled(Layout)`
  color: ${(props) => props.theme.backgrounds.default.fg};
  width: 100%;
  grid-template-columns: 0.2fr 1fr;
`;

const PlaceholderText = styled(Text)`
  justify-self: center;
    white-space: nowrap;
`;
